import React, { useState } from 'react';
import { API } from '../constant';
import Header from "../Components/Header/Header";
import Loading from "../Components/Hooks/Loading";
import Footer from '../Components/Footer/Footer';

const EmailTest = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);

    const addResult = (endpoint, status, message, data) => {
        setResults(prev => [...prev, {
            endpoint,
            status,
            message,
            data,
            timestamp: new Date().toLocaleTimeString()
        }]);
    };

    const testRegistrationEmail = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API}/email/user-registration`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    firstName: 'Test',
                    lastName: 'User',
                    username: 'testuser'
                }),
            });
            const data = await response.json();

            if (response.ok) {
                addResult('User Registration', 'success', 'Email sent successfully!', data);
            } else {
                addResult('User Registration', 'error', 'Failed to send email', data);
            }
        } catch (error) {
            addResult('User Registration', 'error', error.message, null);
        } finally {
            setLoading(false);
        }
    };

    const testForgotPasswordEmail = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API}/email/forget-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();

            if (response.ok) {
                addResult('Forgot Password', 'success', 'Email sent successfully!', data);
            } else {
                addResult('Forgot Password', 'error', 'Failed to send email', data);
            }
        } catch (error) {
            addResult('Forgot Password', 'error', error.message, null);
        } finally {
            setLoading(false);
        }
    };

    const clearResults = () => {
        setResults([]);
    };

    const getStatusColor = (status) => {
        return status === 'success' ? '#4CAF50' : '#f44336';
    };

    return (
        <div className="common-bg">
            {loading && <Loading />}

            <div className="container">
                <Header title="Email Test" />

                <div className="content-wrap bg-blue">
                    <div className="quick-cope">
                        <div className="theme-form">
                            <h2 className="mt---30 mb---20">Email Functionality Test</h2>
                            <p className="mb---20">Test if email endpoints are working correctly</p>

                            <label className="email input-field">
                                <input
                                    className="field-with-icon"
                                    type="email"
                                    value={email}
                                    placeholder="Enter your email to test"
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </label>

                            <div className="mt---20 mb---20">
                                <button
                                    className="btn btn-gradient btn-full btn-white mb---10"
                                    onClick={testRegistrationEmail}
                                    disabled={!email || loading}
                                >
                                    Test Registration Email
                                </button>

                                <button
                                    className="btn btn-gradient btn-full btn-white mb---10"
                                    onClick={testForgotPasswordEmail}
                                    disabled={!email || loading}
                                >
                                    Test Forgot Password Email
                                </button>

                                {results.length > 0 && (
                                    <button
                                        className="btn btn-link btn-white mt---10"
                                        onClick={clearResults}
                                    >
                                        Clear Results
                                    </button>
                                )}
                            </div>

                            {/* Results Display */}
                            {results.length > 0 && (
                                <div className="mt---30">
                                    <h3>Test Results:</h3>
                                    <div style={{
                                        maxHeight: '400px',
                                        overflowY: 'auto',
                                        background: '#fff',
                                        padding: '20px',
                                        borderRadius: '8px',
                                        marginTop: '20px'
                                    }}>
                                        {results.map((result, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    padding: '15px',
                                                    marginBottom: '10px',
                                                    border: `2px solid ${getStatusColor(result.status)}`,
                                                    borderRadius: '5px',
                                                    backgroundColor: result.status === 'success' ? '#f1f8f4' : '#fef1f1'
                                                }}
                                            >
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: '10px'
                                                }}>
                                                    <strong>{result.endpoint}</strong>
                                                    <span style={{ fontSize: '0.9em', color: '#666' }}>
                                                        {result.timestamp}
                                                    </span>
                                                </div>

                                                <div style={{
                                                    color: getStatusColor(result.status),
                                                    fontWeight: 'bold',
                                                    marginBottom: '5px'
                                                }}>
                                                    {result.status.toUpperCase()}
                                                </div>

                                                <div style={{ marginBottom: '10px' }}>
                                                    {result.message}
                                                </div>

                                                {result.data && (
                                                    <details style={{ marginTop: '10px' }}>
                                                        <summary style={{ cursor: 'pointer', color: '#666' }}>
                                                            View Response Data
                                                        </summary>
                                                        <pre style={{
                                                            background: '#f5f5f5',
                                                            padding: '10px',
                                                            borderRadius: '4px',
                                                            overflow: 'auto',
                                                            fontSize: '0.85em',
                                                            marginTop: '10px'
                                                        }}>
                                                            {JSON.stringify(result.data, null, 2)}
                                                        </pre>
                                                    </details>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="mt---30" style={{
                                background: '#fff',
                                padding: '20px',
                                borderRadius: '8px',
                                fontSize: '0.9em',
                                color: '#666'
                            }}>
                                <h4 style={{ marginBottom: '10px', color: '#333' }}>Notes:</h4>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>This tests the email API endpoints only</li>
                                    <li>Check your email inbox (and spam folder) after testing</li>
                                    <li>Email configuration is managed on the backend at: <code>{API}</code></li>
                                    <li>If emails fail, check backend Strapi email plugin settings</li>
                                    <li>Console logs are also available in browser DevTools</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    );
};

export default EmailTest;
